export default {
  // Set rewards timestamp
  rewardsTimestamp(state) {
    state.rewardsTimestamp = String(Math.round(new Date().getTime() / 1000));
  },
  // Reset rewards timestamp
  rewardTimestampReset(state) {
    state.rewardsTimestamp = null;
  },
  // Set rewards
  rewards(state, payload) {
    state.rewards = payload;
  },
  // Set claims
  claims(state, payload) {
    state.claims = payload;
  },
  // Set pending claims
  pendingClaims(state, payload) {
    state.pendingClaims = payload;
  },
};
